(() => {
  if (window.__tacEnrollmentInstalled) return;
  window.__tacEnrollmentInstalled = true;
  const bridge = 'https://tac-razorpay-subscriptions.the-avo-company-checkout.workers.dev';
  const checkout = 'button[name="checkout"],input[name="checkout"],.cart__checkout-button';
  let busy = false, selection, dialog;
  const money = value => new Intl.NumberFormat('en-IN', {style:'currency',currency:'INR'}).format(value/100);
  async function cart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {cache:'no-store'});
    if (!response.ok) throw new Error('Unable to refresh your cart. Please try again.');
    return response.json();
  }
  function select(data) {
    const items = data.items || [];
    if (items.length !== 1) throw new Error('For this test, keep one subscription selection in your cart. Mixed carts are not supported yet.');
    const item = items[0], props = item.properties || {};
    if (item.quantity !== 1) throw new Error('Select the 1, 2, 3 or 6 Can/Set tier on the product page, then add that selection once.');
    if (!item.selling_plan_allocation && props._tac_subscription !== 'true') throw new Error('Please re-add your subscription with its delivery frequency.');
    const label = Object.entries(props).filter(([key]) => /frequency|subscription/i.test(key)).map(([,value]) => value).concat(item.selling_plan_allocation?.selling_plan?.name || '').join(' ');
    const match = label.match(/(?:every\s*)?([123])\s*(?:months?|$)/i);
    const frequencyMonths = match ? Number(match[1]) : /every\s+month/i.test(label) ? 1 : 0;
    if (!frequencyMonths) throw new Error('Delivery frequency is missing. Please re-add your subscription.');
    const amount = props._tac_subscription === 'true' ? Math.round(item.final_line_price * .9) : item.final_line_price;
    const single = ['pure-avocado-oil','extra-virgin-avocado-oil','100-pure-avocado-oil-spray'].includes(item.handle);
    const tier = single ? String(item.variant_title || '').replace(/Sets?/gi, match => match.toLowerCase() === 'sets' ? 'Cans' : 'Can') : item.variant_title || '';
    return {variantId:String(item.variant_id), frequencyMonths, amount, title:item.product_title || item.title, tier};
  }
  function modal() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'tac-enrollment';
    dialog.setAttribute('aria-labelledby','tac-enrollment-title');
    const fields = [['firstName','First name','text','given-name'],['lastName','Last name','text','family-name'],['email','Email','email','email'],['phone','Phone','tel','tel'],['address1','Address','text','street-address'],['city','City','text','address-level2'],['province','State','text','address-level1'],['zip','PIN code','text','postal-code']];
    dialog.innerHTML = '<button type="button" data-close aria-label="Close delivery details">×</button><p>SUBSCRIBE &amp; SAVE · TEST CHECKOUT</p><h2 id="tac-enrollment-title">Delivery details</h2><p data-summary></p><p>Enter your address once, then approve recurring payments securely with Razorpay.</p><form><div class="tac-enrollment-fields">' + fields.map(([name,label,type,autocomplete]) => `<label>${label}${name === 'address1' ? '<textarea rows="3" maxlength="100"' : `<input type="${type}" maxlength="120"`} name="${name}" autocomplete="${autocomplete}" required${name === 'zip' ? ' pattern="[0-9]{6}" inputmode="numeric"' : ''}>${name === 'address1' ? '</textarea>' : ''}</label>`).join('') + '</div><p role="alert" data-error></p><button type="submit">Continue to Razorpay</button><p>Your order is confirmed only after payment verification—not when the mandate window opens.</p></form>';
    const style = document.createElement('style');
    style.textContent = '.tac-enrollment{box-sizing:border-box;margin:0 0 0 auto;width:min(520px,100%);max-width:100%;height:100dvh;max-height:100dvh;padding:24px;border:1px solid #173F2A;border-radius:20px 0 0 20px;background:#FFFDF4;color:#173F2A;overflow:auto;font-family:inherit}.tac-enrollment::backdrop{background:rgb(23 63 42 / .4)}.tac-enrollment h2{font-size:30px;font-family:var(--font-heading--family,inherit)}.tac-enrollment p{font-size:14px;line-height:1.45}.tac-enrollment [data-close]{float:right;width:40px;height:40px;border:1px solid;border-radius:50%;background:transparent;color:inherit;font-size:24px}.tac-enrollment-fields{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:14px}.tac-enrollment label{display:grid;gap:6px;font-size:14px;min-width:0}.tac-enrollment label:has(textarea){grid-column:1/-1}.tac-enrollment input,.tac-enrollment textarea{box-sizing:border-box;width:100%;padding:12px;border:1px solid #173F2A;border-radius:12px;background:white;color:inherit;font:inherit;font-size:16px}.tac-enrollment button[type=submit]{width:100%;padding:15px;margin:16px 0;border:1px solid #173F2A;border-radius:100px;background:#DCEB4F;color:#173F2A;box-shadow:4px 4px 0 #173F2A;font:inherit;font-weight:600}.tac-enrollment button[type=submit]:active{transform:translate(4px,4px);box-shadow:none}.tac-enrollment [data-error]{color:#a32222}';
    document.head.append(style); document.body.append(dialog);
    dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('form').addEventListener('submit', async event => {
      event.preventDefault();
      const form = event.currentTarget, button = form.querySelector('button[type=submit]'), error = dialog.querySelector('[data-error]');
      if (busy || !form.reportValidity()) return;
      busy = true; button.disabled = true; error.textContent = '';
      try {
        const healthResponse = await fetch(`${bridge}/health`), health = await healthResponse.json();
        if (!healthResponse.ok || !health.ok || health.environment !== 'test') throw new Error('Test subscription service is unavailable. No payment has been started.');
        if (JSON.stringify(select(await cart())) !== JSON.stringify(selection)) throw new Error('Your cart changed. Close this form and restart checkout.');
        const customer = Object.fromEntries(new FormData(form)); customer.address2 = '';
        const response = await fetch(`${bridge}/api/subscriptions/create`,{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({variantId:selection.variantId,frequencyMonths:selection.frequencyMonths,cartTotalPaise:selection.amount,customer})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'Unable to create your subscription. Please try again.');
        const url = new URL(result.checkoutUrl);
        if (url.protocol !== 'https:' || !['rzp.io','rzp.in','razorpay.com'].some(host=>url.hostname === host || url.hostname.endsWith(`.${host}`))) throw new Error('Unexpected payment destination. Checkout stopped.');
        if (Number(result.amount) !== selection.amount) throw new Error('Payment amount mismatch. Checkout stopped.');
        window.location.assign(url.href);
      } catch (reason) { error.textContent = reason.message || 'Unable to start secure checkout.'; }
      finally { busy = false; button.disabled = false; }
    });
    return dialog;
  }
  async function begin(event, button) {
    event.preventDefault(); event.stopImmediatePropagation(); event.__tacSubscriptionCheckoutHandled = true;
    if (busy) return;
    busy = true; button.disabled = true;
    try {
      selection = select(await cart());
      const view = modal();
      view.querySelector('[data-summary]').textContent = `${selection.title} · ${selection.tier} · ${money(selection.amount)} every ${selection.frequencyMonths} month${selection.frequencyMonths === 1 ? '' : 's'}`;
      view.querySelector('[data-error]').textContent = '';
      view.querySelector('[name=zip]').value = sessionStorage.getItem('tac_delivery_pincode') || '';
      view.showModal();
    } catch (reason) {
      const host = button.parentElement;
      let error = host.querySelector('.tac-cart-subscription-error');
      if (!error) { error = document.createElement('p'); error.className = 'tac-cart-subscription-error'; error.setAttribute('role','alert'); host.append(error); }
      error.textContent = reason.message;
    } finally { busy = false; button.disabled = false; }
  }
  function intercept(event, button) {
    if (!button || event.__tacSubscriptionCheckoutHandled) return;
    const surface = button.closest('cart-drawer,cart-drawer-component,cart-items-component,.cart-page,form') || document;
    if (surface.querySelector('.cart-items__table-row--subscription')) begin(event,button);
  }
  window.addEventListener('click',event=>intercept(event,event.target.closest?.(checkout)),true);
  window.addEventListener('submit',event=>intercept(event,event.submitter || event.target.querySelector?.(checkout)),true);
})();

(() => {
  if (window.__tacCartCheckoutAssetInstalled) return;
  window.__tacCartCheckoutAssetInstalled = true;

  const checkoutSelector = '.cart__checkout-button';
  const cartSelector =
    'cart-drawer, cart-drawer-component, cart-items-component, .cart-drawer__inner, .cart-page';

  function showError(button, message) {
    const host = button.closest('.cart__ctas') || button.parentElement;
    if (!host) return;

    let error = host.querySelector('.tac-cart-subscription-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'tac-cart-subscription-error';
      error.setAttribute('role', 'alert');
      host.appendChild(error);
    }
    error.textContent = message;
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target?.closest?.(checkoutSelector);
      if (!button) return;

      const cart = button.closest(cartSelector);
      if (!cart) return;

      const hasSubscription = Boolean(cart.querySelector('.cart-items__table-row--subscription'));
      if (!hasSubscription) return;

      const hasOneTime = Boolean(cart.querySelector('.cart-items__table-row--one-time'));
      if (hasOneTime) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError(
          button,
          'Your cart contains both one-time and subscription items. They use separate secure checkouts. Remove one purchase type to continue; the other items can be added again immediately afterward.'
        );
        return;
      }

      if (typeof window.tacBeginCartSubscriptionCheckout === 'function') {
        window.tacBeginCartSubscriptionCheckout(event, button);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      showError(
        button,
        'Subscription checkout is still in preview mode. No payment or mandate has been created.'
      );
    },
    true
  );
})();
